import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Message from '../Common/Message/Message';
import en from './locales/en.json';
import fr from './locales/fr.json';
import editIcon from '../../images/icons/edit.svg';
import statsIcon from '../../images/icons/stats.svg';
import deleteIcon from '../../images/icons/delete.svg';


const strings = SetComponentLanguage(LocalizedStrings, en, fr);
class ManageCoupon extends Component {
    constructor(props) {
        super(props);
        this.state = {
            coupons: [],
            message: {
                title: '',
                content: '',
                type: ''
            },
            showDeleteCouponLightbox: false,
            couponToDeleteId: 0
        }
    }

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    deleteCouponConfirm = (e) => {
        this.setState({
            showDeleteCouponLightbox: true,
            couponToDeleteId: parseInt(e.target.id, 0)
        });
    }

    resetDeleteInfos = () => {
        this.setState({ 
            couponToDeleteId: 0,
            showDeleteCouponLightbox: false
        });
    }

    deleteCoupon = () => {
        const id = this.state.couponToDeleteId;
        if(id === 0) return false;
        (async () => {
            try {
                const deleteCouponResponse = await deleteCoupon();
                console.log('delete coupon response: ', deleteCouponResponse);

                if(deleteCouponResponse.data.success === true){
                    this.setMessage(window.general_strings.msg.yay, strings.msg.success, 'success');
                    this.resetDeleteInfos();
                    this.getCouponsList();
                } else {
                    this.setMessage(window.general_strings.msg.oops, deleteCouponResponse.data.error.code,'error');
                    this.resetDeleteInfos();
                }
            } catch (error) {
                console.log(error);
                this.resetDeleteInfos();
            }
        })()

        async function deleteCoupon() {
            return await ApiRequest(`/coupons/${id}`, {
                method: 'DELETE'
            });
        }
    }

    toggleDeleteCouponLightbox = () => {
        let showLightbox = !this.state.showDeleteCouponLightbox;
        this.setState({
            showDeleteCouponLightbox: showLightbox
        });

        if(!showLightbox) this.resetDeleteInfos();
    }

    getCouponsList = () => {
        (async () => {
            try {
                const couponsListResponse = await couponsList();
                console.log('coupons list response: ', couponsListResponse);

                if(couponsListResponse.data.coupons){
                    var now = moment();
                    
                    let coupons = couponsListResponse.data.coupons.map(c => {
                        let isActive = (now.isAfter(c.expires)) ? false : true;
                        return {
                            id: c.id,
                            name: c.name,
                            isActive: isActive,
                            amount: c.amount,
                            desc: c.desc,
                            codes: c.codes
                        }
                    });

                    this.setState({ 
                        coupons
                    });
                } else {
                    this.setMessage(window.general_strings.msg.oops, couponsListResponse.data.error.code,'error');
                }
            } catch (error) {
                console.log(error);
            }
        })()

        async function couponsList() {
            return await ApiRequest('/coupons', {
                method: 'GET'
            });
        }
    }

    componentDidMount() {
        this.getCouponsList();
    }

    render() { 
        return ( 
            <div>
                <Modal className="modal-md" isOpen={this.state.showDeleteCouponLightbox} toggle={this.toggleDeleteCouponLightbox}>
                    <ModalHeader toggle={this.togglePosterLightbox}>{strings.confirmTitle}</ModalHeader>
                    <ModalBody>
                        {strings.confirmText}
                    </ModalBody>
                    <ModalFooter>
                        <button 
                            type="submit" 
                            className="showtix-button showtix-background__grey-1"
                            onClick={this.toggleDeleteCouponLightbox}>
                            {strings.confirmCancel}
                        </button>
                        <button 
                            type="submit" 
                            className="showtix-button showtix-background__primary-3"
                            onClick={this.deleteCoupon}>
                            {strings.confirmButton}
                        </button>  
                    </ModalFooter>
                </Modal>

                <div className="container">
                    <Message 
                        message={this.state.message}
                    /> 
                </div>

                <div className="showtix-section container">
                    <div className="row">
                        <div className="col-12 col-lg-8">
                            <h1>{strings.title}</h1>
                            <div className="row">
                                <div className="col-12">
                                    <div className="table-responsive">
                                        <table className="showtix-table showtix-table__striped">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 50 }}></th>
                                                    <th>{strings.couponName}</th>
                                                    <th className="text-center">{strings.redemptionCount}</th>
                                                    <th>{strings.status}</th>
                                                    <th style={{ width: 20 }}></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.coupons.map((coupon, i) => {
                                                        const searchUrl = encodeURIComponent(coupon.name);
                                                        let isMultipleCoupon = coupon.codes.length > 1;
                                                        let allowedUses = 0;
                                                        if (coupon.codes[0]) {
                                                            allowedUses = (isMultipleCoupon) ? coupon.codes.length : coupon.codes[0].allowed_uses;
                                                        }
                                                        
                                                        let usedCount = (coupon.codes[0]) ? coupon.codes[0].used_count : 0;
                                                        let multipleCouponRedemption = 0;
                                                        for(var index in coupon.codes) {
                                                            if (coupon.codes[index].used_count > 0) {
                                                                multipleCouponRedemption++;
                                                            }
                                                        }
                                                        let canBeDeleted = false;
                                                        if ((!isMultipleCoupon && usedCount === 0) || (isMultipleCoupon && multipleCouponRedemption === 0)) {
                                                            canBeDeleted = true;
                                                        }

                                                        return (
                                                            <tr key={i}>
                                                                <td style={{ width: 50 }}>
                                                                    <div className="d-flex">
                                                                        <Link to={{ 
                                                                            pathname: `/create-coupon/${coupon.id}`  
                                                                        }}>
                                                                            <img className="edit-icon" src={editIcon} alt="edit icon" />
                                                                        </Link>
                                                                        <Link to={{ 
                                                                            pathname: `/create-coupon/${coupon.id}`,
                                                                            hash: '#review'
                                                                        }}>
                                                                            <img className="stats-icon" src={statsIcon} alt="stats icon" />
                                                                        </Link>
                                                                    </div>    
                                                                </td>
                                                                <td>
                                                                    <Link to={{ 
                                                                        pathname: `/search/${searchUrl}`  
                                                                    }}>
                                                                        {coupon.name}
                                                                    </Link>
                                                                </td>
                                                                <td className="text-center">
                                                                    {!isMultipleCoupon &&
                                                                        <React.Fragment>
                                                                        {usedCount}/{allowedUses}
                                                                        </React.Fragment>
                                                                    }
                                                                    {isMultipleCoupon &&
                                                                        <React.Fragment>
                                                                        {multipleCouponRedemption}/{allowedUses}
                                                                        </React.Fragment>
                                                                    }
                                                                </td>
                                                                <td>
                                                                    { coupon.isActive ? 
                                                                        strings.active
                                                                    :
                                                                        strings.inactive
                                                                    }    
                                                                </td>
                                                                <td>
                                                                    {canBeDeleted &&
                                                                        <img
                                                                            id={coupon.id}
                                                                            className="delete-icon"
                                                                            src={deleteIcon}
                                                                            alt="delete icon"
                                                                            onClick={this.deleteCouponConfirm}
                                                                        />
                                                                    }
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="pt-2 pb-2">
                                        <Link 
                                            className="showtix-button showtix-background__primary-2"
                                            to={{ 
                                                pathname: `/create-coupon/`
                                            }}
                                        >
                                            <span>{strings.addNewCoupon}</span>
                                        </Link>
                                    </div>    
                                </div>
                            </div>
                        </div>
                    </div>         
                </div> 
            </div>   
        )
    }
}
 
export default ManageCoupon;


// WEBPACK FOOTER //
// ./src/components/ManageCoupon/ManageCoupon.js